import { ArrowDown } from 'lucide-react';
import { Illustration } from '../../components/Illustration';
import { cn } from '../../lib/utils';
import { PLANS } from './plans';
import { goToChapter } from './Chapter';
import { CHAPTER_BAR } from './motion';

// The three plans, as the hero's three boxes, in plan order; each one jumps
// to its chapter further down. A box opens with the plan's name on a dark
// strip set as the chapter bars set it, so the box and its chapter read as one,
// then its drawing, its line and a sentence, on surface (the colour the
// drawings are painted on).
export function PlanBoxes() {
  return (
    <ul className="relative mt-24 lg:mt-32 grid md:grid-cols-3 gap-4 lg:gap-6 max-w-6xl mx-auto text-left">
      {PLANS.map((plan, i) => (
        <li key={plan.key} className="flex">
          <a
            href={`#${plan.key}`}
            onClick={(e) => {
              e.preventDefault();
              goToChapter(plan.key);
            }}
            className={cn(
              'group w-full overflow-hidden rounded-tile bg-surface flex flex-col transition-transform duration-200 hover:-translate-y-1',
              // The row's outer top corners curve like the chapter panels below
              i === 0 && 'rounded-tl-[32px] lg:rounded-tl-[48px]',
              i === PLANS.length - 1 && 'rounded-tr-[32px] lg:rounded-tr-[48px]',
            )}
          >
            <p
              className="px-6 lg:px-7 flex items-center justify-center bg-inverse text-inverse-foreground text-xl sm:text-2xl font-normal"
              style={{ height: CHAPTER_BAR }}
            >
              {plan.name}
            </p>
            <div className="p-6 lg:p-7 flex flex-1 flex-col gap-3">
              {/* Wider on phones: the drawing's empty top and bottom are cropped */}
              <Illustration name={plan.art} className="w-full max-w-[220px] mx-auto aspect-[2/1] md:aspect-[4/3] mb-1" />
              <h2 className="text-xl font-normal leading-tight [text-wrap:balance]">{plan.title}</h2>
              <p className="leading-snug text-muted-foreground">{plan.body}</p>
              <ArrowDown
                aria-hidden="true"
                className="mt-auto pt-2 w-6 h-6 text-muted-foreground transition-transform duration-200 group-hover:translate-y-1"
              />
            </div>
          </a>
        </li>
      ))}
    </ul>
  );
}
